module.exports = __webpack_public_path__ + "f4a613c73f19da60cf08aa42b2a9249b.woff2";